export const environment = {
  production: false,
  baseUrl: '',
  useHash: false,
  hmr: false,
  showThemeToggle: true,
  translateText: false,
  collapsibleSidebar: false,
  useAppInsights: false,
  appInsightsInstrumentationKey: 'e6f30bb6-a160-4d69-a8d2-8642430020c1',
  useTimeout: true,
  idleInterval: 1800,
  build: 'Test',
  version: '3.0.11',
  displaySidebar: true,
  displayHemotech: true,
  displayHospitals: true,
  theme: 'light',
  publicApi: 'https://test-hflclicensing.oregon.gov/api/public/',
  privateApi: 'https://test-hflclicensing.oregon.gov/api/private/',
  canManageB2CUsers: true,
  auth: {
    defaultAuth: "B2C",
    useAdIdentity: false,
    b2c: {
      clientId: 'e368d38e-823e-4a44-b9fd-cdaf4945d4dd',
      authority: 'https://hcrqidevb2c.b2clogin.com/',
      authorityDomain: 'hcrqidevb2c.b2clogin.com',
      domain: 'hcrqidevb2c.onmicrosoft.com/',
      signUpSignInPolicy: 'B2C_1_HCRQI_DEV_SUSI',
      scopes: ['openid', 'https://hcrqidevb2c.onmicrosoft.com/e368d38e-823e-4a44-b9fd-cdaf4945d4dd/User.Access'],
      redirectUri: 'https://test-hflclicensing.oregon.gov',
      postLogoutRedirectUri: 'https://test-hflclicensing.oregon.gov'
    },
    aad: {
      clientId: '',
      scopes: [],
      groups: [],
      authority: '',
      redirectUri: '',
    }
  },
  enableHttpsRedirect: true,
  staffInbox: "anthony.dunaway@odhsoha.oregon.gov",
  censusApiKey: '1c9b1ec7b5c1a33e2e28e30c5235d268d79b0e43'
};
